import { GLOBALS } from "config";
import type { SWRConfiguration } from "swr";

export const STORE_KEYS = {
  isPaymentDialogOpen: "store_pay",
  isCardDialogOpen: "store_addCard",
  isChargeDialogOpen: "store_charge",
  chargeProduct: "store_chargeProd",
  isChargeProcessingDialogOpen: "store_chargeStatus",
  singleEpRental: "store_singleEp",
  coinAndRental: "store_coinAndRental",
  isViewerJsLoaded: "viewer_loaded",
  isGenreOpened: "genre_open",
  popup: "popup",
  popupData: "popupData",
  requireSigninPopup: "req_signin_popup",
  requireMailConfirmPopup: "req_mail_confirm_popup",
  waitFreeIntroPopup: "waitfree_intro",
  notification: "notification",
  inAdminMode: "adminMode",
} as const;
export type STORE_KEYS = (typeof STORE_KEYS)[keyof typeof STORE_KEYS];

export const POPUP_TYPES = {
  campaign: "campaign",
  waitfree: "waitfree",
  newarticle: "newarticle",
  recommend: "recommend",
  agreement: "agreement",
  mission: "mission",
} as const;
export type POPUP_TYPES = (typeof POPUP_TYPES)[keyof typeof POPUP_TYPES];

export const READING_SERIES_INDEX_KEY = "users.readingSeries" + GLOBALS.CONTENT_ID;
export const READING_SERIES_ID_KEY = "users.readingSeriesIds" + GLOBALS.CONTENT_ID;
export const WAITFREE_INTRO_SHOWN_KEY = "waitfreeintro_shown";

export function getReadEpKey(seriesHash?: string): string {
  if (seriesHash) {
    return "readep_" + seriesHash;
  } else {
    return "";
  }
}

export const PAYMENT_INTENT_INFO_COOKIE_NAME = "piId";

export const NO_IMAGE_IMG_SRC = "https://cdn.comici.jp/img/preparing_series.svg";

/** SWRの基本オプション。自動再検証をOFFに。 */
export const GLOBAL_SWR_CONFIG: SWRConfiguration = {
  revalidateOnFocus: false,
  revalidateOnReconnect: false,
  shouldRetryOnError: false,
};

export const PAYMENT_FAILED_ERROR = "PaymentFailedError";

export const AUTH_TRANSITION_SOURCE_COOKIE_NAME = "from";
